import React from 'react';
import { summaryVFDropdownFieldData } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/summary-v-f-dropdown.css';


const SummaryVFDropdown = React.memo(({
  fieldData,
}) => {

  const {
    displayValues,
    fieldTitle,
  } = fieldData;

  return (
    <div className="summary-field-v-f-dropdown">
      <p className="field-title">
        {fieldTitle}
      </p>
      <ul className="field-values">
        {
          displayValues.map((item) => (
            <li
              key={item.value}
            >
              <p>
                {item.text}
              </p>
            </li>
          ))
        }
      </ul>
    </div>
  );
});

SummaryVFDropdown.propTypes = {
  fieldData: summaryVFDropdownFieldData,
};

export { SummaryVFDropdown };

